import { render, staticRenderFns } from "./ModalInfoCancelado.vue?vue&type=template&id=1b9b916c"
import script from "./ModalInfoCancelado.vue?vue&type=script&lang=js"
export * from "./ModalInfoCancelado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports